import React, {useEffect, useState} from 'react';
import TextInput from "../../../ui_components/TextInput/TextInput";
import PlaceIcon from '@mui/icons-material/Place';
import LocationInputProperties from "./LocationInputProperties";

const LocationInput: React.FC<LocationInputProperties> = ({
                                                                  value,
                                                                  label,
                                                                  placeholder,
                                                                  required,
                                                                  onChange,
                                                                  disabled,
                                                                  fullWidth = false,
                                                                  className = '',
                                                                  error
                                                              }) => {

    const [name, setName] = useState(value);

    useEffect(() => {
        setName(value);
    }, [value]);

    const onNameChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const newName = event.target.value;
        setName(newName);
        onChange(newName);
    }

    return (
        <TextInput
            error={error}
            label={label + `${required ? '*' : ''}`}
            value={name}
            placeholder={placeholder}
            disabled={disabled}
            onChange={onNameChange}
            startIcon={PlaceIcon}
            className={className}
            fullWidth={fullWidth}
        />
    )
}


export default LocationInput;